import { Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

interface CenteredProps {
    fullPage?: boolean;
    className?: string;
    children?: ReactNode;
}

export const Centered: FC<CenteredProps> = ({ children, className, fullPage }) => (
    <Stack
        className={classNames(fullPage ? 'h-100vh w-100vh' : 'h-100 w-100', className)}
        direction="column"
        justifyContent="center"
        alignItems="center"
    >
        {children}
    </Stack>
);
